import { render, staticRenderFns } from "./UserInfoComponent.vue?vue&type=template&id=5646f917&scoped=true"
import script from "./UserInfoComponent.vue?vue&type=script&lang=js"
export * from "./UserInfoComponent.vue?vue&type=script&lang=js"
import style0 from "./UserInfoComponent.vue?vue&type=style&index=0&id=5646f917&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5646f917",
  null
  
)

export default component.exports